import { render, staticRenderFns } from "./AnswerButtonRow.vue?vue&type=template&id=5b664d90&"
import script from "./AnswerButtonRow.vue?vue&type=script&lang=js&"
export * from "./AnswerButtonRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports